module.exports = __webpack_public_path__ + "assets/img/logo2.e5e0ae45.png";